import { render, staticRenderFns } from "./ai_address_reviewer.vue?vue&type=template&id=78bf7695&scoped=true"
import script from "./ai_address_reviewer.vue?vue&type=script&lang=js"
export * from "./ai_address_reviewer.vue?vue&type=script&lang=js"
import style0 from "./ai_address_reviewer.vue?vue&type=style&index=0&id=78bf7695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf7695",
  null
  
)

export default component.exports